import {defineMessages} from 'react-intl';

export default defineMessages({
    advertiser: {
        id: 'newsletter.components.title.advertiser',
        defaultMessage: 'Receba nossos cupons da {advertiser} e muito mais diretamente em seu email.'
    },
    category: {
        id: 'newsletter.components.title.category',
        defaultMessage: 'Receba nossos cupons de {category} e muito mais diretamente em seu email.'
    },
    default: {
        id: 'newsletter.components.title.default',
        defaultMessage: 'Receba nossos cupons diretamente em seu email.'
    }
});
